
/**
 * Sleep for the given duration in milliseconds.
 */

export default function (ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}
